<template>
<div>
    <ShowAllOrders orderStatus="draft"></ShowAllOrders>
</div>
</template>

<script>
import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
export default {
    name: "DraftTab",
    components: {
        ShowAllOrders
    }
}
</script>

<style>
</style>